import React, { useEffect, useState } from 'react'
import { wordleDb } from '../data/db'
import Button from '@mui/material/Button';
import { Icon } from '@mui/material';
import BackspaceIcon from '@mui/icons-material/Backspace';
import Stack from '@mui/material/Stack';
import styled from 'styled-components';


const StyledKeyboardLink = styled.div`
margin: '5px',
                width: '40px',
                height: '50px',
                background: '#eee',
                display: 'inline-block',
                'border-radius': '6px',
                'line-height': '50px'
`

const keyboardDiv = {
  // margin: '2px',
  // width: '40px',
  // height: '50px',
  // background: '#eee',
  // display: 'inline-block',
  // 'border-radius': '6px',
  // 'line-height': '50px'
}

export default function Keypad({ usedKeys, handleLetterClick }) {
  const [letters, setLetters] = useState(null)

  useEffect(() => {
    setLetters(wordleDb.letters)
  }, [])

  const firstRow = letters?.slice(0, 10)
  const secondRow = letters?.slice(10, 19)
  const thirdRow = letters?.slice(19, 26)
  const fourthRow = letters?.slice(27, 28)

  return (
    <div>
      {/* <div className="keypad">
        {letters && letters.map(l => {
          const color = usedKeys[l.key]
          if (l.key === 'Enter') {
            return <Button variant="contained" onClick={() => handleLetterClick('Enter')} style={{ marginRight: '10px' }}>Enter</Button>
          }
          if (l.key === 'Backspace') {
            return <Button color="error" variant="outlined" onClick={() => handleLetterClick('Backspace')}>
              <BackspaceIcon size="small" />
            </Button>
          }
          return (
            <div key={l.key} className={color} onClick={() => handleLetterClick(l.key)}>{l.key.toUpperCase()}</div>
          )
        })}
      </div> */}

      <Stack spacing={0} direction="row" className="keypad" sx={{
        justifyContent: "center",
        alignItems: "center",
      }}
      >
        {firstRow && firstRow.map(l => {
          const color = usedKeys[l.key]
          return (
            <div
              key={l.key} className={color} onClick={() => handleLetterClick(l.key)}>{l.key.toUpperCase()}</div>
          )
        })}
      </Stack>
      <Stack spacing={0} direction="row" className="keypad" sx={{
        justifyContent: "center",
        alignItems: "center",
      }}
      >
        {secondRow && secondRow.map(l => {
          const color = usedKeys[l.key]
          return (
            <div
              key={l.key} className={color} onClick={() => handleLetterClick(l.key)}>{l.key.toUpperCase()}</div>
          )
        })}
      </Stack>
      <Stack spacing={0} direction="row" className="keypad" sx={{
        justifyContent: "center",
        alignItems: "center",
      }}
      >
        {thirdRow && thirdRow.map(l => {
          const color = usedKeys[l.key]
          console.log("color1", color);
          if (l.key === 'Enter') {
            return <Button size='small' variant="contained" onClick={() => handleLetterClick('Enter')} style={{ marginRight: '2px' }}>Enter</Button>
          }
          if (l.key === 'Backspace') {
            return <Button size='small' color="error" variant="outlined" onClick={() => handleLetterClick('Backspace')}>
              <BackspaceIcon size="small" />
            </Button>
          }
          return (
            <div
              key={l.key} className={color} onClick={() => handleLetterClick(l.key)}>{l.key.toUpperCase()}</div>
          )
        })}

      </Stack>
      <Stack spacing={0} direction="row" className="keypad" sx={{
        justifyContent: "center",
        alignItems: "center",
        marginTop: "10px"
      }}
      >
        <Button variant="contained" onClick={() => handleLetterClick('Enter')} style={{ marginRight: '20px' }}>Enter</Button>
        <Button color="error" variant="outlined" onClick={() => handleLetterClick('Backspace')}>
          Del
          <BackspaceIcon size="small" />
        </Button>
      </Stack>
      {/* <hr /> */}

    </div>
  )
}
